import React from "react";
import {
    Dialog as RadixDialog,
    DialogContent,
    DialogTrigger, DialogFooter, DialogHeader,
    DialogTitle
} from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { TriggerButtons } from "@/components/units/action/triggerButtons";

export const Dialog: React.FC<{
    isOpen: boolean;
    setIsOpen: (val: boolean) => void;
    children: React.ReactNode;
}> = React.memo(({ isOpen, setIsOpen, children }) => { 
    
    return (
    <RadixDialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger asChild>
            <TriggerButtons />
        </DialogTrigger>
        <DialogContent className="se-vapor se-vapor-dialog tw:flex-col tw:z-max">
            <DialogHeader>
                <VisuallyHidden>
                    <DialogTitle>Unit Details</DialogTitle>
                </VisuallyHidden>
            </DialogHeader>
            {children}
            <DialogFooter />

        </DialogContent>
    </RadixDialog>
)});
